import axios from 'axios';
import { FileResult } from '../../components_v2/input/model/Model';
import { URL_FOUNDATION } from '../../config/keys';

export type GetFile = {
	uuid: string,
	company_id: number,
	path: string,
	created_by: number,
	created_at: string,
	updated_at: string,
	deleted_at?: string,
	icon_id?: string | null,
	icon_url?: string | null,
	url?: string,

}

type PostFileDb = {
	path: string,
	uuid?: string, // dirs have no uuids
	filesize: number,
}

type GetPostGetPresignedUrl = {
	url: string,
	uuid: string,
}

export async function getUsage(): Promise<number> {
	return axios.get(`${URL_FOUNDATION}/api/v2/filemanager/quota`).then((res) => res.data);
}

export async function postFileManagerGetUrl(): Promise<GetPostGetPresignedUrl> {
	return axios.get(`${URL_FOUNDATION}/api/v2/filemanager/upload`).then((res) => res.data);
}

export async function confirmFileManagerPost(file: PostFileDb): Promise<string> {
	return axios.post(`${URL_FOUNDATION}/api/v2/filemanager/upload`, file).then((res) => res.data);
}

export async function postToS3(url: string, file: FileResult): Promise<Response> {
	return fetch(url, { body: file.file, mode: 'cors', method:'PUT' }).then((res) => res);
}

export async function rename(old_path: string, new_path: string): Promise<string> {
	return axios.put(`${URL_FOUNDATION}/api/v2/filemanager/rename`, { old_path: old_path, new_path: new_path }).then((res) => res.data);
}

export async function getPath(path: string): Promise<GetFile[]> {
	while (path.charAt(0) === '/')
		path = path.slice(1);
	path = path.split('#').join('%23');
	path = path.split('?').join('%3F');
	return axios.get(`${URL_FOUNDATION}/api/v2/filemanager/files/${path}`).then((res) => res.data);
}

export async function deleteUuid(uuid: string): Promise<string> {
	return axios.delete(`${URL_FOUNDATION}/api/v2/filemanager/${uuid}`).then((res) => res.data);
}

export type DriveRestriction = {
	id: number,
	path: string,
	users: number[],
	groups: number[],
}

export async function getDriveRestrictions(): Promise<DriveRestriction[]> {
	return axios.get(`${URL_FOUNDATION}/api/v2/filemanager/restrictions`).then((res) => res.data);
}

export async function setFileIcon(uuid: string, iconId: string | null): Promise<void> {
	return axios.put(`${URL_FOUNDATION}/api/v2/filemanager/${uuid}/icon`, { icon_id: iconId }).then((res) => res.data);
}
